import { APIs } from '@/enums/APIs';
import { AppointmentPlusApiService } from '@/services/appointment_plus/AppointmentPlusApiService';
import { NovaApiService } from '@/services/nova/NovaApiService';

type AppointmentPlusClientParams = {
  api: APIs.AP;
  credentials: {
    userName: string;
    password: string;
  };
  url: string;
};

type NovaClientParams = {
  api: APIs.NOVA;
  token: string;
};

export function getClient(params: AppointmentPlusClientParams): AppointmentPlusApiService;
export function getClient(params: NovaClientParams): NovaApiService;
export function getClient(
  params: AppointmentPlusClientParams | NovaClientParams
): AppointmentPlusApiService | NovaApiService {
  if (params.api === APIs.NOVA) {
    return new NovaApiService({ token: params.token });
  }
  return new AppointmentPlusApiService({
    userName: params.credentials.userName,
    password: params.credentials.password,
    url: params.url
  });
}
